//i18n-setup.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import store from './store';
import _ from 'lodash';
import { unflatten } from './services/helper';

Vue.use(VueI18n);

const messages = {
  'en-US': require('@/lang/en-US.json'),
};

export const i18n = new VueI18n({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages,
});
export const tbase = (base: string, keyword: string): string => {
  const key = base + keyword;
  return i18n.te(key) ? <string>i18n.t(key) : keyword;
};
export function translateList(list: SelectOption[], baseKeyword?: string): SelectOption[] {
  const base = baseKeyword + '.';
  let getT = (x: SelectOption) => <string>i18n.t(x.Text);
  if (baseKeyword) getT = (x) => tbase(base, x.Text);
  return list.map((x) => {
    const n = _.clone(x);
    n.Text = getT(x);
    return n;
  });
}
Vue.prototype.$tbase = tbase;

store.commit('UpdateLang', i18n.locale);

const loadedLanguages = ['en-US'];

function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html')!.setAttribute('lang', lang);
  return lang;
}

var defaultOverride: any = null;
function mergeLang(lang: string, override: any) {
  if (!override) return;
  i18n.mergeLocaleMessage(lang, unflatten(override));
}
function applyClientLang(lang: string) {
  if (defaultOverride == null) {
    try {
      defaultOverride = require(`@/lang/client-${process.env.VUE_APP_CLIENT}.json`) || {};
    } catch (err) {
      defaultOverride = {};
    }
  }
  mergeLang(lang, defaultOverride['default']);
  mergeLang(lang, defaultOverride[lang]);
}

export async function loadLanguageAsync(lang: string) {
  // If the same language
  if (i18n.locale === lang) {
    applyClientLang(lang);
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    const result = Promise.resolve(setI18nLanguage(lang));
    store.commit('UpdateLang', lang);
    return result;
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default);

    applyClientLang(lang);

    loadedLanguages.push(lang);
    const result = Promise.resolve(setI18nLanguage(lang));
    store.commit('UpdateLang', lang);
    return result;
  });
}

export const locales = [
  {
    name: 'he-IL',
    text: 'עִברִית',
    dir: 'rtl',
    twoLetter: 'he',
    image: 'img/israel.svg',
  },
  {
    name: 'ru-RU',
    text: 'Русский',
    dir: 'ltr',
    twoLetter: 'ru',
    image: 'img/russia.svg',
  },
  {
    name: 'en-US',
    text: 'English',
    dir: 'ltr',
    twoLetter: 'en',
    image: 'img/usa.svg',
  },
  {
    name: 'ar-SA',
    text: 'عربيه',
    dir: 'rtl',
    twoLetter: 'ar',
    image: 'img/arabic.svg',
  },
];
